module.exports = __webpack_public_path__ + "media/gallery.25f34ef6.mp4";